<template>
    <div class="messageBox" >
      <p>
          {{ this.info }}
      </p>
      <p> 
          {{ this.question }}
      </p>

      <footer>
        <b-button 
            v-if="question"
            variant="danger" 
            id="confirm"
            @click="accept()"
            :title="$t('confirmar')"
            :alt="$t('confirmar')">
            {{$t('yes')}}
        </b-button>

        <b-button 
            v-if="question"
            :title="$t('cancelar')"
            :alt="$t('cancelar')"
            @click="close()"
            >
            {{$t('no')}}
        </b-button>

        <b-button  
        v-if="info"
        :title="$t('ok')"
        :alt="$t('ok')"
        @click="close()"
        >
        Ok
    </b-button>
      </footer>
    </div>
</template>

<script>
    export default {
        props: { 
          info: {
            type: String
          },
          question: {
            type: String,
            requied: true
          },
          action: {
            type: Function,
            requied: true,
          },
          modelname: {
            type: String,
            requied: true
          },
        },

        methods: {
            close() {
                this.$emit("cancelAction", false)
                this.$bvModal.hide(this.modelname);
            },

            accept(){
              this.action()
              this.$bvModal.hide(this.modelname);
            },
        },

        mounted() {
        },
    }
</script>

<style scoped>

.messageBox {
    padding: 5px;
    margin: 0;
    border: none;
    display: flex; 
    flex-direction: column;
    justify-content: center;
    width: 100%;
    border-radius: 7px;
    background-color: #fff;
}

.messageBox>p{
    text-align: center;
    padding: 10px 10px 0 10px;
    margin: 0;
    overflow: auto;
}

.messageBox>p:nth-child(3){
    padding: 0px 10px 10px 10px;
}

.header {
    border-top-right-radius: 7px;
    border-top-left-radius: 7px;
    margin: 0;
    padding: 2px 15px;
    text-align: left;
    font-size: 1.15em;
    widows: 100%;
}

footer{
    margin-top: 20px;
    border-top: 1px solid #ccc;
    flex-direction: row;
    padding-right: 10px;
}

button {
    cursor: pointer;
    float: right;
    width: 60px;
    margin: 10px 7px 5px 0;
}

button:nth-child(1){
    margin: 10px 5px 5px 0;
}

@media (max-width: 550px) { 
    .messageBox {
    width: 330px;
    top: calc(50% - 100px);
    left: calc(50% - 165px);
    }

    .messageBox>p{
        padding: 5px;
    }
}

</style>